import { render, staticRenderFns } from "./OccupationChip.vue?vue&type=template&id=2737cfe4&scoped=true&"
import script from "./OccupationChip.vue?vue&type=script&lang=js&"
export * from "./OccupationChip.vue?vue&type=script&lang=js&"
import style0 from "./OccupationChip.vue?vue&type=style&index=0&id=2737cfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2737cfe4",
  null
  
)

export default component.exports